<template>
  <el-row v-loading="pageLoading">
    <el-col :span="5">
      <div style="overflow-y: scroll">
        <div id="leftTreeId" style="height: 775px">
          <basic-container>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
            <el-tree
              class="filter-tree"
              :props="treeProps"
              node-key="id"
              ref="leftTreeRef"
              :load="lazyLoadLeftTree"
              :filter-node-method="filterNode"
              lazy
              @node-click="nodeClick"
            >
            </el-tree>
          </basic-container>
        </div>
      </div>
    </el-col>
    <el-col :span="19">
      <basic-container id="mainContainerId">
        <avue-crud
          :option="propertyOption"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          :permission="permissionList"
          :before-open="beforeOpen"
          v-model="form"
          ref="crud"
          @row-update="rowUpdate"
          @row-save="rowSave"
          @row-del="rowDel"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @on-load="onLoad"
          @refresh-change="onLoad"
        >
          <template slot="menuLeft" justify="start">
            <!-- 展示当前点选节点信息 -->
            <!-- <el-button :disabled='true' type="primary" plain style="margin-right: 8px">{{ choosenNode.title || '---' }} </el-button> -->
            <el-tag size="large" style="margin-right: 8px">{{ choosenNode.title || '---' }}</el-tag>
            <!-- 选择框 -->
            <div style="display: inline-block; margin-right: 8px" v-if="permissionList.addBtn">
              <el-select
                v-model="choosenObjectType"
                placeholder="添加下级"
                @change="objectTypeChange"
                @focus="objectTypeFocus"
              >
                <el-option
                  v-for="item in objectTypes"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </div>
            <el-button
              type="primary"
              icon="el-icon-edit"
              v-if="permissionList.editBtn"
              @click="editNode"
            >
              编辑节点
            </el-button>

            <el-button
              type="danger"
              icon="el-icon-delete"
              size="small"
              plain
              v-if="permissionList.delBtn"
              @click="deleteNode"
            >
              删除节点
            </el-button>
          </template>

          <template slot="menu" slot-scope="scope">
            <el-button
              v-if="permissionList.viewBtn"
              type="text"
              icon="el-icon-edit"
              size="small"
              @click.native="openPropertyViewDialog(scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="permissionList.editBtn"
              type="text"
              icon="el-icon-edit"
              size="small"
              @click.native="openPropertyEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="permissionList.delBtn"
              type="text"
              icon="el-icon-delete"
              size="small"
              @click.native="rowDel(scope.row)"
              >删除</el-button
            >
          </template>
        </avue-crud>
        <!-- 新增/编辑  楼栋/单元/楼层弹窗-->
        <el-dialog
          :visible.sync="nodeAddDialog"
          :title="'添加' + addDialogTitle"
          :modal-append-to-body="true"
          :append-to-body="true"
          :destroy-on-close="true"
          @close="closeNodeAddDialog"
        >
          <avue-form
            ref="nodeAddFormRef"
            v-model="nodeAddForm"
            :option="nodeAddOption"
            @reset-change="nodeAddReset"
            @submit="nodeAddSubmit"
          >
            <template slot="menuForm">
              <el-button @click="quitNodeAddDialog">退出</el-button>
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          :visible.sync="nodeEditDialog"
          :title="'编辑' + editDialogTitle"
          :modal-append-to-body="false"
          :append-to-body="true"
          :destroy-on-close="true"
          @opened="nodeEditDialogOpened"
          @close="closeNodeEditDialog"
        >
          <avue-form
            ref="nodeEditFormRef"
            v-model="nodeEditForm"
            :option="nodeEditOption"
            @reset-change="nodeEditReset"
            @submit="nodeEditSubmit"
          >
            <template slot="menuForm">
              <el-button @click="quitNodeEditDialog">退出</el-button>
            </template>
          </avue-form>
        </el-dialog>
        <!-- 新增/编辑/查看  房间弹窗-->
        <el-dialog
          :visible.sync="propertyAddShowDialogFlag"
          title="新增房间"
          :modal-append-to-body="false"
          :append-to-body="true"
          destroy-on-close="true"
          @opened="propertyAddDialogOpened"
          @close="propertyAddDialogClose"
        >
          <avue-form
            v-if="propertyAddShowDialogFlag"
            ref="propertyAddFormRef"
            v-model="propertyAddForm"
            :option="propertyAddOption"
            @reset-change="propertyAddReset"
            @submit="propertyAddSubmit"
          >
            <template slot="menuForm">
              <el-button @click="quitPropertyAddDialog">退出</el-button>
            </template>
          </avue-form>
        </el-dialog>

        <el-dialog
          :visible.sync="propertyEditShowDialogFlag"
          title="编辑房间"
          :append-to-body="true"
          :destroy-on-close="true"
          @opened="propertyEditDialogOpened"
          @close="propertyEditDialogClose"
        >
          <avue-form
            v-if="propertyEditShowDialogFlag"
            ref="propertyEditFormRef"
            v-model="propertyEditForm"
            :option="propertyEditOption"
            @reset-change="propertyEditReset"
            @submit="propertyEditSubmit"
          >
            <el-form label-width="80px" label-position="left">
              <el-row>
                <el-form-item label="成员管理"> </el-form-item>
              </el-row>
              <el-row gutter="30">
                <el-col span="8">
                  <el-input value="123" :disabled="true"></el-input>
                </el-col>
                <el-col span="8">
                  <el-input value="123" :disabled="true"></el-input>
                </el-col>
                <el-col span="8">
                  <el-input value="123" :disabled="true"></el-input>
                </el-col>
              </el-row>
            </el-form>
            <template slot="menuForm">
              <el-button @click="quitPropertyEditDialog">退出</el-button>
            </template>
          </avue-form>
        </el-dialog>

        <el-dialog
          :visible.sync="propertyViewShowDialogFlag"
          title="查看房间"
          :append-to-body="true"
          destroy-on-close="true"
          @opened="propertyViewDialogOpened"
          @close="propertyViewDialogClose"
        >
          <avue-form
            v-if="propertyViewShowDialogFlag"
            ref="propertyViewFormRef"
            v-model="propertyViewForm"
            :option="propertyViewOption"
            @reset-change="propertyViewReset"
          >
          </avue-form>
        </el-dialog>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import {
  addNode,
  addProperty,
  getDetailById,
  getList,
  getRoomInfo,
  getTreeChildrenNode2,
  removeNode,
  removeProperty,
  updateNode,
  updateProperty,
  getDict,
  getRoomMember,
  getUseTypes,
} from '@/api/v4ward/property/baseproperty';
import { mapGetters } from 'vuex';
import treeOption from './tree-option';
import propertyAddOption from './property-add-option';
import propertyOption from './property-option';
import propertyEditOption from './property-edit-option';
import nodeAddOption from './node-add-option';
import nodeEditOption from './node-edit-option';
import propertyViewOption from './property-view-option';

export default {
  data() {
    return {
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
        //节点数据权限
        dataPower: 'dataPower',
      },
      leftTreeRoot: {},
      leftTreeResolve: {},

      // isNodeAddDialogFirstOpen: true,
      // nodeAddParentNodeTreeRoot: {},
      // nodeAddParentNodeTreeResolve: {},
      // isPropertyAddDialogFirstOpen: true,
      // propertyAddParentNodeTreeRoot: {},
      // propertyAddParentNodeTreeResolve: {},

      //选中的树形节点信息
      treeTrackId: '',
      filterText: '',

      //选中的表格行信息
      tableTrackId: '',

      //父节点树结构相关信息
      parentId: '',
      parentObjectName: '',
      parentObjectType: 0,
      parentObjectTypeName: '',

      query: {},
      loading: true,

      treeOption: treeOption,
      nodeAddOption: nodeAddOption,
      nodeEditOption: nodeEditOption,
      propertyOption: propertyOption,
      propertyAddOption: propertyAddOption,
      propertyEditOption: propertyEditOption,
      propertyViewOption: propertyViewOption,

      //页面数据
      treeData: [],
      data: [],

      //数据权限
      DATA_POWER_NULL: 0,
      DATA_POWER_VIEW: 1,
      DATA_POWER_VIEW_EDIT: 2,
      DATA_POWER_VIEW_EDIT_DEL: 3,
      tableUseType: '',
      //
      pageLoading: false,
      objectTypesAll: [],
      objectTypes: [],
      choosenObjectType: '',
      choosenNode: {},
      choosenNodeParent: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      nodeAddForm: {},
      nodeAddDialog: false,
      addDialogTitle: '',
      nodeEditForm: {},
      nodeEditDialog: false,
      editDialogTitle: '',
      //窗口显示开关
      propertyAddShowDialogFlag: false,
      propertyEditShowDialogFlag: false,
      propertyViewShowDialogFlag: false,
      //form表单数据
      form: {},
      propertyAddForm: {},
      propertyEditForm: {},
      propertyViewForm: {},
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.baseproperty_add_node, false),
        viewBtn: this.vaildData(this.permission.baseproperty_view_node, false),
        delBtn: this.vaildData(this.permission.baseproperty_delete_node, false),
        editBtn: this.vaildData(this.permission.baseproperty_edit_node, false),
      };
    },
  },
  async created() {
    this.pageLoading = true;
    try {
      let resObjectTypes = await getDict('object_type');
      this.objectTypesAll = resObjectTypes.data;
    } catch (err) {
      console.log('err init data==>', err);
    }
    this.pageLoading = false;
  },
  mounted() {
    console.log('this.permission==>', this.permission);
  },
  watch: {
    filterText(val) {
      this.$refs.leftTreeRef.filter(val);
    },
  },
  methods: {
    //懒加载树结构
    lazyLoadLeftTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.leftTreeRoot = node;
        this.leftTreeResolve = resolve;
      } else {
        id = node.data.id;
      }
      getTreeChildrenNode2({ id: id }).then(({ data }) => {
        resolve(data);
      });
    },
    reloadLeftTree() {
      this.leftTreeRoot.childNodes = [];
      this.lazyLoadLeftTree(this.leftTreeRoot, this.leftTreeResolve);
    },
    //点击左侧树结构回调
    nodeClick(data) {
      console.log('data node click==>', data);
      //1-小区;2-建筑体(暂未使用);3-楼栋;4-单元;5-楼层;6-房间
      switch (data.objectType) {
        case 1:
          this.objectTypes = this.objectTypesAll.filter((item) => ['3'].includes(item.dictKey));
          break;
        case 3:
          this.objectTypes = this.objectTypesAll.filter((item) =>
            ['4', '5', '6'].includes(item.dictKey)
          );
          break;
        case 4:
          this.objectTypes = this.objectTypesAll.filter((item) =>
            ['5', '6'].includes(item.dictKey)
          );
          break;
        case 5:
          this.objectTypes = this.objectTypesAll.filter((item) => ['6'].includes(item.dictKey));
          break;
        default:
          this.objectTypes = [];
      }
      this.choosenNode = data;
      this.treeTrackId = data.id;
      this.choosenObjectType = '';
      this.page.currentPage = 1;
      this.onLoad();
    },
    objectTypeChange(value) {
      this.addDialogTitle = this.getObjectTypeNameByKey(Number(value));
      //3-楼栋;4-单元;5-楼层;6-房间
      if (['3', '4', '5'].includes(value)) {
        this.openNodeAddDialog();
      } else if (['6'].includes(value)) {
        this.openPropertyAddDialog();
      }
    },
    objectTypeFocus() {
      console.log('focus==>');
      if (!this.choosenNode.id) {
        this.$message.error('请在左侧树形列表中选择节点');
      }
      if (this.choosenNode.objectType == 6) {
        this.$message.error('房间无下级');
      }
    },
    openNodeAddDialog() {
      this.nodeAddForm = {
        parentId: this.choosenNode.id,
        parentObjectName: this.choosenNode.title,
        objectType: this.choosenObjectType,
      };
      this.nodeAddDialog = true;
    },
    quitNodeAddDialog() {
      this.nodeAddDialog = false;
    },
    closeNodeAddDialog() {
      this.choosenObjectType = '';
      this.$refs.nodeAddFormRef.resetForm();
    },
    nodeAddReset() {},
    openNodeEditDialog() {
      getDetailById({ id: this.choosenNode.id })
        .then((res) => {
          this.nodeEditForm = res.data;
          this.editDialogTitle = this.getObjectTypeNameByKey(Number(res.data.objectType));
          this.nodeEditDialog = true;
        })
        .catch((err) => {
          console.log('err getDetailById==>', err);
        });
    },
    quitNodeEditDialog() {
      this.nodeEditDialog = false;
    },
    closeNodeEditDialog() {
      this.$refs.nodeEditFormRef.resetForm();
      this.nodeEditDialog = false;
    },
    nodeEditReset() {},
    //树节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data[this.treeProps.label].indexOf(value) !== -1;
    },
    editNode() {
      if (this.treeTrackId) {
        let node = this.$refs.leftTreeRef.getNode(this.treeTrackId);
        console.log('node==>', node);
        let data = node.data;
        if (data.objectType == 1) {
          this.$message.error('小区无法编辑');
        } else {
          //3-楼栋;4-单元;5-楼层
          if (['3', '4', '5'].includes(String(data.objectType))) {
            this.openNodeEditDialog();
            //6-房间
          } else if (['6'].includes(String(data.objectType))) {
            this.openPropertyEditDialog(this.choosenNode);
          }
        }
        console.log('node==>', data);
      } else {
        this.$message.error('请在左侧树形列表中选择节点!');
      }
    },
    deleteNode() {
      if (this.treeTrackId) {
        const node = this.choosenNode;
        console.log('this.choosenNode==>', this.choosenNode);
        if (node.objectType == 1) {
          this.$message.error('小区无法删除！');
          return;
        }
        if (!node.isLeaf) {
          this.$message.error('该节点下有子节点，不允许删除！');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return removeNode({ id: this.treeTrackId });
          })
          .then(() => {
            this.reloadLeftTree();
            this.onLoad();
            this.choosenNode = {};
            this.treeTrackId = '';
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      } else {
        this.$message.error('请在左侧树形列表中选择节点!');
      }
    },
    openPropertyAddDialog() {
      this.propertyAddForm = {
        parentId: this.choosenNode.id,
        parentObjectName: this.choosenNode.title,
        objectType: this.choosenObjectType,
      };
      this.pageLoading = true;
      Promise.all([getDict('room_status'), getUseTypes()])
        .then((res) => {
          this.propertyAddOption.column[8].dicData = res[0].data;
          this.propertyAddForm.roomStatus = res[0].data[0].dictKey;
          this.propertyAddOption.column[3].dicData = res[1].data;
          this.propertyAddForm.useType = res[1].data[0].dictKey;
          this.pageLoading = false;
          this.propertyAddShowDialogFlag = true;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log('err==>', err);
        });
    },
    openPropertyEditDialog(data) {
      this.loadRoomInfoAndRoomMembers(data, 'edit');
    },
    openPropertyViewDialog(row) {
      this.loadRoomInfoAndRoomMembers(row, 'view');
    },
    loadRoomInfoAndRoomMembers(data, type) {
      console.log('data==>', data);
      //type:'view','edit'
      const params = { id: data.id };
      Promise.all([getRoomInfo(params), getRoomMember(params)]).then((res) => {
        console.log('res==>', res);
        const roomInfo = res[0].data;
        //通过修改avue-form配置的方式显示'成员管理'数据;
        const members = res[1].data;
        let membersOption = [];
        members.forEach((ele, idx) => {
          membersOption.push(
            {
              prop: 'householdName' + idx,
              label: '',
              labelWidth: 0,
              disabled: true,
              span: 8,
              value: ele.householdName || '',
            },
            {
              prop: 'householdTypeName' + idx,
              labelWidth: 0,
              disabled: true,
              span: 8,
              value: ele.householdTypeName || '',
            },
            {
              prop: 'linkPhone' + idx,
              labelWidth: 0,
              disabled: true,
              span: 8,
              value: ele.linkPhone || '',
            }
          );
        });
        console.log('membersOption==>', membersOption);
        if (type == 'edit') {
          this.propertyEditForm = roomInfo;
          this.propertyEditOption.group[1].column = membersOption;
          this.propertyEditShowDialogFlag = true;
        }
        if (type == 'view') {
          this.propertyViewForm = roomInfo;
          this.propertyViewOption.group[1].column = membersOption;
          this.propertyViewShowDialogFlag = true;
        }
      });
    },
    nodeEditDialogOpened() {},
    propertyAddDialogOpened() {},
    propertyEditDialogOpened() {},
    propertyViewDialogOpened() {},
    propertyAddReset() {},
    propertyEditReset() {},
    nodeAddSubmit(form, done) {
      console.log('form add==>', form);
      this.$refs.nodeAddFormRef.validate((valid) => {
        if (valid) {
          addNode(form).then(
            () => {
              this.reloadLeftTree();
              this.onLoad();
              // this.choosenNode = {};
              this.$message.success('操作成功!');
              this.nodeAddDialog = false;
              this.$refs.nodeAddFormRef.resetForm();
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    nodeEditSubmit(form, done) {
      console.log('form edit==>', form);
      this.$refs.nodeEditFormRef.validate((valid) => {
        if (valid) {
          updateNode(form).then(
            () => {
              this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.nodeEditDialog = false;
              this.$refs.nodeEditFormRef.resetForm();
              this.choosenNode = {};
              this.treeTrackId = '';
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    propertyAddSubmit(form, done) {
      console.log('form propertyAdd==>', form);
      this.$refs.propertyAddFormRef.validate((valid) => {
        if (valid) {
          //占用铺位默认为0
          form.bedUsing = 0;
          // addProperty(form, this.query).then(
          addProperty(form).then(
            () => {
              this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.propertyAddShowDialogFlag = false;
              // this.$refs.propertyAddFormRef.resetForm();
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    propertyEditSubmit(form, done) {
      this.$refs.propertyEditFormRef.validate((valid) => {
        if (valid) {
          updateProperty(form).then(
            () => {
              this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.propertyEditShowDialogFlag = false;
              this.$refs.propertyEditFormRef.resetForm();
              this.bedCapacity = 0;
              this.bedUsing = 0;
              this.editIsShow = false;
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    propertyAddDialogClose() {
      this.choosenObjectType = '';
      this.propertyAddShowDialogFlag = false;
    },
    propertyViewDialogClose() {
      this.propertyViewShowDialogFlag = false;
    },
    propertyEditDialogClose() {
      this.propertyEditShowDialogFlag = false;
    },
    quitPropertyAddDialog() {
      this.propertyAddShowDialogFlag = false;
    },
    quitPropertyEditDialog() {
      this.propertyEditShowDialogFlag = false;
    },
    rowSave(row, loading, done) {
      console.log('row save==>');
      // add(row).then(
      //   () => {
      //     this.onLoad();
      //     done();
      //     this.$message.success('操作成功!');
      //   },
      //   (error) => {
      //     loading();
      //     console.log(error);
      //   }
      // );
    },
    rowUpdate(row, index, loading, done) {
      console.log('row update==>');
      // update(row).then(
      //   () => {
      //     this.onLoad();
      //     done();
      //     this.$message.success('操作成功!');
      //   },
      //   (error) => {
      //     loading();
      //     console.log(error);
      //   }
      // );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeProperty({ ids: row.id });
        })
        .then(() => {
          this.reloadLeftTree();
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    beforeOpen(done, type) {
      console.log('beforeOpen==>', 123);
      // if (['edit', 'view'].includes(type)) {
      //   getDetail({ id: this.form.id }).then(({ data }) => {
      //     this.form = data;
      //   });
      // }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange() {},
    selectionClear() {},
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize, treeTrackId: this.treeTrackId },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.data.forEach((ele) => {
          ele.roomStatus = ele.roomStatus + '';
          ele.useType = ele.useType + '';
        });
        this.loading = false;
        this.selectionClear();
        this.setTreeHeight();
      });
    },
    setTreeHeight() {
      let mainHeight = document.getElementById('mainContainerId').offsetHeight;
      document.getElementById('leftTreeId').style.height = mainHeight - 10 + 'px';
    },
    getObjectTypeNameByKey(key) {
      switch (key) {
        case 1:
          return '小区';
        case 2:
          return '建筑体';
        case 3:
          return '楼栋';
        case 4:
          return '单元';
        case 5:
          return '楼层';
        case 6:
          return '房间';
        default:
          return '未识别类型';
      }
    },
  },
};
</script>

<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 500px;
  overflow: auto;
}

.el-property-dialog-div {
  height: inherit;
  overflow: auto;
}
</style>
